import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { getSections } from '../api';

const DraftKingsSection = () => {
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSection = async () => {
      try {
        const sections = await getSections();
        const draftkings = sections.find(s => s.section_type === 'draftkings');
        setSection(draftkings);
      } catch (error) {
        console.error('Error fetching DraftKings section:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSection();
  }, []);

  if (loading || !section) return null;

  return (
    <section className="w-full relative py-20 px-6 overflow-hidden">
      {/* Gradient Background with Darker Shade */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-500 via-green-600 to-green-700"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-green-600/20 to-green-800/40"></div>
      
      <div className="max-w-5xl mx-auto relative z-10">
        {/* H2 - Title with lighter background */}
        <div className="bg-green-600/50 backdrop-blur-sm rounded-2xl p-6 mb-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            {section.title}
          </h2>
        </div>
        
        {/* H3 + Content + Image in darker background */}
        <div className="bg-green-800/60 backdrop-blur-sm rounded-2xl p-8">
          <h3 className="text-2xl md:text-3xl font-semibold text-white mb-6">
            {section.subtitle}
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Description */}
            <div className="text-white">
              <p className="text-lg mb-8 leading-relaxed whitespace-pre-wrap">
                {section.description}
              </p>
              <a href={section.link} target="_blank" rel="noopener noreferrer">
                <Button className="bg-black text-white hover:bg-gray-900 rounded-full px-8 py-3 text-base font-semibold transition-all duration-200">
                  Learn More
                </Button>
              </a>
            </div>

            {/* Image */}
            <div className="relative rounded-xl overflow-hidden shadow-2xl">
              <img
                src={section.image}
                alt={section.title}
                className="w-full h-80 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DraftKingsSection;